import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
  width: '100%',
};

export const tabsContainer: SxStyle = {
  height: (p) => p.spacing(5),
};

export const title: SxStyleFunc = ({
  isActive,
  comingSoon,
}: {
  isActive: boolean;
  comingSoon: boolean;
}) => ({
  width: 'fit-content',
  pb: (p) => p.spacing(0.5),
  fontSize: (p) => p.typography.body2,
  fontWeight: isActive ? 700 : 400,
  borderBottomWidth: isActive ? '2px' : '0px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.primary[500],
  cursor: !isActive ? 'pointer' : 'default',
  color: (p) => (comingSoon ? p.palette.grey[400] : p.palette.primary[500]),
});
